import { CheckUtils } from "../check-utils";
var CollectionConverter = /** @class */ (function () {
    function CollectionConverter() {
    }
    CollectionConverter.convertToArray = function (values, target) {
        if (CheckUtils.isEmpty(values) || CheckUtils.isEmpty(target))
            return;
        target.splice(0, target.length);
        target = target.concat(values);
        return target;
    };
    return CollectionConverter;
}());
export { CollectionConverter };
//# sourceMappingURL=collection-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/collection-converter.js
// module id = 964
// module chunks = 14